import { authClient, API } from "../index";
import { safeGet } from "../../utils/safeGet";


export const getBusinessByQrId = (id) => {
  return safeGet(`${API}/business/qr/${id}`);
};

export const getBusinessById = (id) => {
  return safeGet(`${API}/business/${id}`);
};

export const getRatingByBusiness = (id) => {
  return authClient().get(`${API}/business/rating/${id}`);
};